let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1YGpr")).then(() => parcelRequire('49I3w'));